import Axios from "./Axios";
import API_URL from "./URLS";

/// public page api's

export const GET_HOME = (data) => Axios.get(API_URL.GET_HOME, data);
export const GET_SERVICES_TYPES = (data) =>
  Axios.post(API_URL.GET_SERVICES_TYPES, data);


export const GET_DOCUMENTS=(data) => Axios.get(API_URL.GET_DOCUMENTS,{params:data})

export const GET_PICK_UP_LISTING = (data) =>
  Axios.post(API_URL.GET_PICK_UP_LISTING, data);
export const GET_ESTIMATED_PRICE = (data) =>
  Axios.post(API_URL.GET_ESTIMATED_PRICE, data);
export const PICKUP_DROP_SAVE = (data) =>
  Axios.post(API_URL.PICKUP_DROP_SAVE, data);
//////////////////

export const LOGIN_ADMIN = (data) => Axios.post(API_URL.LOGIN_ADMIN, data);
export const FORGET_PASSWORD_ADMIN = (data) =>
  Axios.post(API_URL.FORGET_PASSWORD_ADMIN, data);
export const OTP_VERIFY = (data) => Axios.post(API_URL.OTP_VERIFY, data);
export const RESET_PASSWORD = (data) =>
  Axios.post(API_URL.RESET_PASSWORD, data);
export const CHANGE_PASSWORD = (data) =>
  Axios.post(API_URL.CHANGE_PASSWORD, data);
export const AMDIN_UPDATE = (data) => Axios.post(API_URL.AMDIN_UPDATE, data);

// bird eye view
export const BIRD_EYE_VIEW = (data) => Axios.post(API_URL.BIRD_EYE_VIEW, data);

// dashbaord
export const GET_DASHBOARD_DATA = (data) =>
  Axios.post(API_URL.GET_DASHBOARD_DATA, data);
export const GET_CUSTOMERS = (data) => Axios.post(API_URL.GET_CUSTOMERS, data);
export const GET_TIERS = (data) => Axios.get(API_URL.GET_TIERS, data);
export const GET_NOTIFY = (data) =>
  Axios.post(API_URL.GET_NOTIFY, data, {
    params: {
      page: data?.page,
      limit: data?.limit,
    },
  });
export const SEND_NOTIFY_EMAIL = (data) =>
  Axios.post(API_URL.SEND_NOTIFY_EMAIL, data);

export const BLOCK_UNBLOCK_CUSTOMER = (data) =>
  Axios.post(API_URL.BLOCK_UNBLOCK_CUSTOMER, data);
export const BLOCK_UNBLOCK_TIER = (data) =>
  Axios.patch(API_URL.BLOCK_UNBLOCK_TIER, data);
export const GET_CUSTOMERS_BY_ID = (data) =>
  Axios.post(API_URL.GET_CUSTOMERS_BY_ID + data);

export const EXPORT_CUSTOMER_CSV = (data) =>
  Axios.get(API_URL.EXPORT_CUSTOMER_CSV);
export const IMPORT_CUSTOMER_CSV = (data) =>
  Axios.post(API_URL.IMPORT_CUSTOMER_CSV, data);

// PROMOTIONS
export const GET_PROMOTIONS = (data) =>
  Axios.post(API_URL.GET_PROMOTIONS, data);
export const PROMOTION_STATUS_UPDATE = (data) =>
  Axios.post(API_URL.PROMOTION_STATUS_UPDATE, data);
export const PROMOTION_DELETE = (data) =>
  Axios.delete(API_URL.PROMOTION_DELETE + data);
export const PROMOTION_EDIT = (data) =>
  Axios.post(API_URL.PROMOTION_EDIT, data);
export const PROMOTION_ADD = (data) => Axios.post(API_URL.PROMOTION_ADD, data);
export const GET_PROMOTION_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMOTION_BY_ID + data);

// promoCodes
export const GET_PROMO_CODES = (data) =>
  Axios.post(API_URL.GET_PROMO_CODES, data);
export const ADD_PROMO_CODE = (data) =>
  Axios.post(API_URL.ADD_PROMO_CODE, data);
export const DELETE_PROMO_CODE = (data) =>
  Axios.delete(API_URL.DELETE_PROMO_CODE + data);
export const GET_PROMO_CODE_BY_ID = (data) =>
  Axios.get(API_URL.GET_PROMO_CODE_BY_ID + data);
export const PROMO_CODE_EDIT = (data) =>
  Axios.post(API_URL.PROMO_CODE_EDIT, data);

// sytem access
export const ADD_ADMIN = (data) => Axios.post(API_URL.ADD_ADMIN, data);
export const REMOVE_ADMIN = (data) => Axios.post(API_URL.REMOVE_ADMIN, data);
export const GET_ADMIN_LIST = (data) =>
  Axios.post(API_URL.GET_ADMIN_LIST, data);
export const GET_ADMIN_BY_ID = (data) =>
  Axios.post(API_URL.GET_ADMIN_BY_ID + data);
export const EDIT_SYSTEM_ADMIN = (data) =>
  Axios.post(API_URL.EDIT_SYSTEM_ADMIN, data);

// manage bookings

export const GET_MANAGE_BOOKINGS = (data) =>
  Axios.post(API_URL.GET_MANAGE_BOOKINGS, data);

export const GET_MANAGE_BOOKING_DETAILS = (data) =>
  Axios.get(API_URL.GET_MANAGE_BOOKING_DETAILS + data);

// services
export const GET_SERVICES = (data) => Axios.post(API_URL.GET_SERVICES, data);
export const GET_SERVICE_BY_ID = (data) =>
  Axios.get(API_URL.GET_SERVICE_BY_ID + data);
export const REMOVE_SERVICE = (data) =>
  Axios.post(API_URL.REMOVE_SERVICE, data);
export const EDIT_SERVICE = (data) => Axios.post(API_URL.EDIT_SERVICE, data);
export const ADD_SERVICE = (data) => Axios.post(API_URL.ADD_SERVICE, data);
export const BLOCK_UNBLOCK_SERVICE = (data) =>
  Axios.post(API_URL.BLOCK_UNBLOCK_SERVICE, data);

// reports
export const GET_DRIVERS_REPORTS = (data) =>
  Axios.post(API_URL.GET_DRIVERS_REPORTS, data);
export const EXPORT_DRIVERREPORT_CSV = (data) =>
  Axios.get(API_URL.EXPORT_DRIVERREPORT_CSV);

// accounting

export const GET_ACCOUNTING_DATA = (data) =>
  Axios.get(API_URL.GET_ACCOUNTING_DATA);
export const EXPORT_ACCOUNTING_CSV = (data) =>
  Axios.get(API_URL.EXPORT_ACCOUNTING_CSV);

// fare request

export const GET_FARE_REQUESTS = (data) =>
  Axios.post(API_URL.GET_FARE_REQUESTS, data);
export const GET_FARE_REQUEST_VIEW = (data) =>
  Axios.post(API_URL.GET_FARE_REQUEST_VIEW + data);
export const FARE_REQUEST_APPROVE = (data) =>
  Axios.post(API_URL.FARE_REQUEST_APPROVE, data);

// AGENCIES
export const GET_AGENCIES = (data, params) =>
  Axios.post(API_URL.GET_AGENCIES + params, data);
export const APPROVING_AGENCY = (data) =>
  Axios.post(API_URL.APPROVING_AGENCY, data);
export const BLOCK_UNBLOCK_AGENCY = (data) =>
  Axios.post(API_URL.BLOCK_UNBLOCK_AGENCY, data);
export const GET_AGENCY_VIEW = (data) =>
  Axios.post(API_URL.GET_AGENCY_VIEW + data);
export const ADD_AGENCY = (data) => Axios.post(API_URL.ADD_AGENCY, data);
export const UPDATE_AGENCY = (data) => Axios.post(API_URL.UPDATE_AGENCY, data);
export const DELETE_AGENCY = (data) => Axios.post(API_URL.DELETE_AGENCY, data);
export const GET_AGENCY_BY_ID = (data) =>
  Axios.get(API_URL.GET_AGENCY_BY_ID + data);
export const EXPORT_AGENCIES_CSV = (data) =>
  Axios.get(API_URL.EXPORT_AGENCIES_CSV);
export const IMPORT_AGENCIES_CSV = (data) =>
  Axios.post(API_URL.IMPORT_AGENCIES_CSV, data);

// drivers
export const GET_DRIVERS = (data, params) =>
  Axios.post(API_URL.GET_DRIVERS + params, data);
export const APPROVING_DRIVER = (data) =>
  Axios.post(API_URL.APPROVING_DRIVER, data);
export const BLOCK_UNBLOCK_DRIVER = (data) =>
  Axios.post(API_URL.BLOCK_UNBLOCK_DRIVER, data);
export const VIEW_DRIVER = (data) => Axios.post(API_URL.VIEW_DRIVER + data);
export const ADD_DRIVER = (data) => Axios.post(API_URL.ADD_DRIVER, data);
export const UPDATE_DRIVER = (data) => Axios.post(API_URL.UPDATE_DRIVER, data);
export const DELETE_DRIVER = (data) => Axios.post(API_URL.DELETE_DRIVER, data);
export const GET_DRIVER_BY_ID = (data) =>
  Axios.get(API_URL.GET_DRIVER_BY_ID + data);
export const EXPORT_DRIVERS_CSV = (data) =>
  Axios.get(API_URL.EXPORT_DRIVERS_CSV);
export const IMPORT_DRIVERS_CSV = (data) =>
  Axios.post(API_URL.IMPORT_DRIVERS_CSV, data);
export const VERIFY_UPLOADED_DOCUMENTS = (data) =>
  Axios.patch(API_URL.VERIFY_UPLOADED_DOCUMENTS, data);
export const REJECT_UPLOADED_DOCUMENTS = (data) =>
  Axios.patch(API_URL.REJECT_UPLOADED_DOCUMENTS, data);
export const GET_TIER_VEHICLES=(id)=> Axios.get(API_URL.GET_TIERS_VEHICLES+id)

// disputes
export const GET_DISPUTES = (data) => Axios.post(API_URL.GET_DISPUTES, data);
export const GET_DISPUTE_VIEW = (data) =>
  Axios.post(API_URL.GET_DISPUTE_VIEW + data);
export const UPDATE_STATUS_DISPUTE = (data) =>
  Axios.post(API_URL.UPDATE_STATUS_DISPUTE, data);

// file upload
export const FILE_UPLOAD = (data) => Axios.post(API_URL.FILE_UPLOAD, data);
// ================= SETTINGS =================== //

export const BASIC_SETTING_DETAILS = (data) =>
  Axios.get(API_URL.BASIC_SETTING_DETAILS);
export const GET_CONFIG_DETAILS = (data) =>
  Axios.get(API_URL.GET_CONFIG_DETAILS);

export const BASIC_SETTING_UPDATE = (data) => {
  console.log("data api", data);
  return Axios.post(API_URL.BASIC_SETTING_UPDATE, data);
};
export const GET_CONFIG_UPDATE = (data) =>
  Axios.post(API_URL.GET_CONFIG_UPDATE, data);
export const GET_MAIL_UPDATE = (data) =>
  Axios.post(API_URL.GET_MAIL_UPDATE, data);
export const PAYMENT_CONFIG_UPDATE = (data) =>
  Axios.post(API_URL.PAYMENT_CONFIG_UPDATE, data);

export const ANDROID_VERSION_UPDATE = (data) =>
  Axios.post(API_URL.ANDROID_VERSION_UPDATE, data);

export const ANDROID_APP_URL_UPDATE = (data) =>
  Axios.post(API_URL.ANDROID_APP_URL_UPDATE, data);
export const IOS_APP_URL_UPDATE = (data) =>
  Axios.post(API_URL.IOS_APP_URL_UPDATE, data);
export const GET_MAIL_TEMPLATES = (data) =>
  Axios.get(API_URL.GET_MAIL_TEMPLATES);
export const GET_SMS_TEMPLATES = (data) => Axios.get(API_URL.GET_SMS_TEMPLATES);

export const MAIL_TEMPLATES_UPDATE = (data) =>
  Axios.post(API_URL.MAIL_TEMPLATES_UPDATE, data);
export const SMS_TEMPLATES_UPDATE = (data) =>
  Axios.post(API_URL.SMS_TEMPLATES_UPDATE, data);

// FAQ
export const FAQ_LIST = (data) => Axios.post(API_URL.FAQ_LIST, data);
export const ADD_FAQ = (data) => Axios.post(API_URL.ADD_FAQ, data);
export const GET_FAQ_BY_ID = (data) => Axios.get(API_URL.GET_FAQ_BY_ID + data);
export const EDIT_FAQ = (data) => Axios.post(API_URL.EDIT_FAQ, data);
export const DELETE_FAQ = (data) => Axios.post(API_URL.DELETE_FAQ, data);
export const STATUS_CHANGE_FAQ = (data) =>
  Axios.post(API_URL.STATUS_CHANGE_FAQ, data);

// CONTENT
export const CONTENTPAGE_LIST = (data) =>
  Axios.post(API_URL.CONTENTPAGE_LIST, data);
export const CONTENTPAGE_EDIT = (data) =>
  Axios.post(API_URL.CONTENTPAGE_EDIT, data);
export const CONTENT_LIST_DETAILS = (data) =>
  Axios.get(API_URL.CONTENT_LIST_DETAILS + data);
export const STATUS_CHANGE_CONTENT = (data) =>
  Axios.post(API_URL.STATUS_CHANGE_CONTENT, data);


// vendor 
export const GET_MANAGE_VENDOR = (data) =>
  Axios.post(API_URL.GET_MANAGE_VENDOR, data);
export const GET_MANAGE_VENDOR_DETAILS = (data) =>
  Axios.get(API_URL.GET_MANAGE_VENDOR_DETAILS + data);

// payment
export const ADD_CARD = (data) =>
  Axios.post(API_URL.ADD_CARD, data);

export const MAKE_PAYMENT = (data) =>
  Axios.post(API_URL.MAKE_PAYMENT, data);

export const VENDOR_STRIPE_CONNECT = (data) =>
  Axios.post(API_URL.VENDOR_STRIPE_CONNECT, data);

export const VENDOR_STRIPE_CONNECT_DETAIL = (data, params) =>
  Axios.get(API_URL.VENDOR_STRIPE_CONNECT_DETAIL + params, data);

export const VENDOR_SIGNUP = (data) =>
  Axios.post(API_URL.VENDOR_SIGNUP, data);

// vendors
export const GET_VENDORS = (data) => Axios.post(API_URL.GET_VENDORS, data);
export const GET_VENDOR_BY_ID = (data) =>
  Axios.get(API_URL.GET_VENDOR_BY_ID + data);
export const REMOVE_VENDOR = (data) =>
  Axios.post(API_URL.REMOVE_VENDOR, data);
export const EDIT_VENDOR = (data) => Axios.post(API_URL.EDIT_VENDOR, data);
export const ADD_VENDOR = (data) => Axios.post(API_URL.ADD_VENDOR, data);
export const BLOCK_UNBLOCK_VENDOR = (data) =>
  Axios.post(API_URL.BLOCK_UNBLOCK_VENDOR, data);


// assign driver
export const GET_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.GET_ASSIGN_DRIVER, data);
export const BOOKING_GUEST_ASSIGN_DRIVER = (data) =>
  Axios.post(API_URL.BOOKING_GUEST_ASSIGN_DRIVER, data);
